import { render, staticRenderFns } from "./BboxContainer.vue?vue&type=template&id=e2d32726&scoped=true"
import script from "./BboxContainer.vue?vue&type=script&lang=js"
export * from "./BboxContainer.vue?vue&type=script&lang=js"
import style0 from "./BboxContainer.vue?vue&type=style&index=0&id=e2d32726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d32726",
  null
  
)

export default component.exports